import { useIntl } from 'react-intl'
import { RoleRow } from '../../model/RoleRow'
import { PermissionPolicyOption } from '../../model/PermissionPolicyOption'
import { ICellRendererParams } from 'ag-grid-community'
import { MultiLineTooltip } from '../../../../components/tooltips/Tooltip/MultiLineTooltip'
import { RootDiv } from '../../../../containers/commons/AgGrid/components/cell/CellRendererRoot'
import { colorPalette } from '../../../../style/colorPalette'
import { useAvailableFunctionsTooltipGetter } from './availableFunctionsTooltip'

type UseAvailableFunctionsProps = {
  permissionPolicyOptions: PermissionPolicyOption[]
}

export const useAvailableFunctionsCellRenderer = ({
  permissionPolicyOptions,
}: UseAvailableFunctionsProps) => {
  const intl = useIntl()
  const { getAvailableFunctionsTooltipOfRole } =
    useAvailableFunctionsTooltipGetter()

  const cellRenderer = (params: ICellRendererParams<RoleRow>) => {
    const tooltip = params.data
      ? getAvailableFunctionsTooltipOfRole(params.data, permissionPolicyOptions)
      : ''

    return (
      <RootDiv>
        <MultiLineTooltip message={tooltip}>
          <span style={{ cursor: 'pointer', color: colorPalette.skyBlue[8] }}>
            {intl.formatMessage({ id: 'confirm' })}
          </span>
        </MultiLineTooltip>
      </RootDiv>
    )
  }

  return cellRenderer
}
